/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery',
	'doT',
	'../ExtensionBaseView',
	'text!./templates/EmptyDataSet.html',
	'../../dataSources/nls/StringResources'
], function($, doT, BaseView, EmptyDatasetTemplate, StringResources) {
	'use strict';

	class DataSourcesView extends BaseView {

		constructor(options){
			super(options);
		}

		/**
 		 * Render empty dataset
		 * @param {HTMLElement} container - DOM node to render into
		 */
		static renderEmptyDataset (container){
			BaseView.clearContainer(container);
			const html = doT.template(EmptyDatasetTemplate)({ nls: StringResources });
			$(container).html(html);
			return Promise.resolve(container);
		}

		/**
 		 * Render the MUI grid
		 * 
		 * @param {object} module - Module to render
		 * @param {boolean} enableDataQuality - Enable data quality
		 * @param {HTMLElement} container - DOM node to render into
		 */
		static renderMUIGrid (module, enableDataQuality, container, dashboard){
			BaseView.clearContainer(container);
			return module.getShapingUIUtils().renderGrid(module, enableDataQuality, container, /* selectedId */null, dashboard)
				.then(() => container);
		}
	}


	return DataSourcesView;
});